import { render, staticRenderFns } from "./s-clock.vue?vue&type=template&id=688a8f67&scoped=true&"
import script from "./s-clock.vue?vue&type=script&lang=js&"
export * from "./s-clock.vue?vue&type=script&lang=js&"
import style0 from "./s-clock.vue?vue&type=style&index=0&id=688a8f67&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688a8f67",
  null
  
)

export default component.exports